import Worker from 'worker-loader!./worker';
import * as Comlink from 'comlink'
const worker =  Comlink.wrap(new Worker());

export const toUpperCase1 = worker.toUpperCase1;

export const searchZip = worker.searchZip;

export const searchZip2 = worker.searchZip2;